export const BARNSLEY_1 = "barnsley1";
export const BARNSLEY_2 = "barnsley2";
export const BARNSLEY_3 = "barnsley3";
export const BARNSLEY_4 = "barnsley4";
export const BARNSLEY_5 = "barnsley5";

export const LONDON_1 = "london1";
export const LONDON_2 = "london2";
export const LONDON_2_BTN = "london2-button";
export const LONDON_3 = "london3";
export const LONDON_3_BTN = "london3-button";
export const LONDON_4 = "london4";
export const LONDON_5 = "london5";

export const LEAVESDEN_1 = "leavesden1";
export const LEAVESDEN_2 = "leavesden2";
export const LEAVESDEN_3 = "leavesden3";
export const LEAVESDEN_4 = "leavesden4";

export const CREATIVE_1 = "creative1";
export const CREATIVE_2 = "creative2";
export const CREATIVE_3 = "creative3";
export const CREATIVE_4 = "creative4";

export const CREATIVE_BOLD_1 = "creative-bold1";
export const CREATIVE_BOLD_2 = "creative-bold2";
export const CREATIVE_BOLD_3 = "creative-bold3";
export const CREATIVE_BOLD_4 = "creative-bold4";
export const CREATIVE_BOLD_5 = "creative-bold5";

export const BOOK = "book";
export const BOLD = "bold";
export const CREATIVE = "creative";
export const CREATIVE_BOLD = "creativeBold";

export const FUTURA = "futura-pt";
